export default {
  /**
   * 处理图表数据
   * @param {Object} rawData  图表原始数据
   * @param {Object} config   配置项
   * @return {Object}         图表可用的配置
   */
  getOptions (rawData, config) {
    const data = rawData.reverse()
    const placeholderValues = this.translateData(data)
    const maxLength = 23
    return {
      tooltip: Object.assign({
        trigger: 'item',
        padding: 10,
        formatter: `{b} : {c}${config.unit || ''}`,
        backgroundColor: 'rgba(61, 61, 61, 0.95)',
        extraCssText: 'box-shadow: 0 4px 9px rgba(0, 0, 0, 0.3); border-radius: 8px;'
      }),
      grid: Object.assign({
        containLabel: true,
        left: 20,
        right: 20,
        top: 10,
        bottom: -20
      }),
      xAxis: Object.assign({
        type: 'value',
        show: false,
        max: rawData.length ? rawData[rawData.length - 1].value * 1.3 : 1
      }),
      yAxis: Object.assign({
        type: 'category',
        data: [],
        show: false
      }),
      series: [
        // 第一个条形图只用于显示上方name
        {
          itemStyle: {
            barBorderRadius: [0, 3, 3, 0],
            color: config.color,
            borderWidth: 30,
            borderColor: 'rgba(0, 0, 0, 0)'
          },
          type: 'bar',
          barWidth: 7,
          stack: 'bar',
          label: {
            normal: {
              show: true,
              distance: -10,
              color: '#4a4a4a',
              position: [16, -5],
              formatter: function (f) {
                var name = f.name
                if (maxLength && name.length > maxLength) {
                  name = name.substring(0, maxLength) + '...'
                }
                return name
              }
            }
          },
          data: placeholderValues
        },
        // 第二个条形图只用于显示条和右侧数字
        {
          itemStyle: {
            barBorderRadius: [0, 3, 3, 0],
            color: config.color,
            borderWidth: 30,
            borderColor: 'rgba(0, 0, 0, 0)'
          },
          cursor: config.cursor || 'pointer',
          type: 'bar',
          barWidth: 7,
          stack: 'bar',
          label: {
            normal: {
              show: true,
              color: '#4a4a4a',
              position: ['96%', '36%'],
              formatter: function (f) {
                return config.unit ? (f.value + '' + config.unit) : undefined
              }
            }
          },
          data: data
        }
      ]
    }
  },
  /**
   * 转换原始数据拆成图表的x,y,series各组
   * @param {Object} data   图表原始数据
   * @param {Object} config 各组件所需配置
   * @return {Object}       转换后的数据
   */
  translateData (data) {
    let placeholderValues = []
    data.forEach(function (key) {
      placeholderValues.push({
        name: key.description,
        value: 0
      })
    })
    return placeholderValues
  }
}
